function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var s = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var k = Object.prototype.hasOwnProperty,
    b = Object.prototype.propertyIsEnumerable;

var i = function i(a, r, o) {
  return r in a ? s(a, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : a[r] = o;
},
    t = function t(a, r) {
  for (var o in r || (r = {})) {
    k.call(r, o) && i(a, o, r[o]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(r)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        b.call(r, o) && i(a, o, r[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

import e, { createRef as m } from "react";
import { SnackbarProvider as S } from "notistack";
import { SnackbarAction as d } from "./SnackbarAction";
import "./snackbars.css";

var g = function g(a) {
  var r = m(),
      o = function o(c) {
    (r == null ? void 0 : r.current) && r.current.closeSnackbar(c);
  };

  return e.createElement(S, t({
    ref: r,
    classes: {
      root: "snackbar",
      containerRoot: "snackbars"
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    action: function action(c) {
      return e.createElement(d, {
        onClick: function onClick() {
          return o(c);
        }
      }, "Dismiss");
    }
  }, a));
};

export { g as SnackbarProvider };